var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "#0a63f3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 32h256v64H128zM480 128H32c-17.6 0-32 14.4-32 32v160c0 17.6 14.397 32 32 32h96v128h256V352h96c17.6 0 32-14.4 32-32V160c0-17.6-14.4-32-32-32M64 224c-17.673 0-32-14.327-32-32s14.327-32 32-32 32 14.327 32 32-14.326 32-32 32m288 224H160V288h192z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterBlue);
export default __webpack_public_path__ + "static/media/printer-blue.53805c033f1983105f7a9edd1538445d.svg";
export { ForwardRef as ReactComponent };